import React from 'react'
import { useRef, useDispatch, useTimeout, useOn } from 'hooks'
import Portal from 'components/Portal'
import Icon from 'components/Icon'
import StyledModal from './StyledModal'
import { MESSAGE_MODAL } from './modalTypes'
import { modalType } from 'common/types'
import { clearModal } from 'store/actions'

const Modal = ({ modalId, children, onClose, close, transparentBackground, contentProps }) => {
  const modalRef = useRef()
  const dispatch = useDispatch()
  const closeModal = close.disabled
    ? () => {}
    : () => {
        onClose()
        dispatch(clearModal(modalId))
      }
  useTimeout(closeModal, close.timeout)
  useOn({
    click: e => {
      close.overlay && !modalRef.current?.contains(e.target) && closeModal()
    },
    keydown: e => {
      close.escape && e.key == 'Escape' && closeModal()
    },
  })

  return (
    <Portal>
      <StyledModal transparentBackground={transparentBackground}>
        <div className="content" ref={modalRef} {...contentProps}>
          {close.button && (
            <span className="close-btn" onClick={closeModal}>
              <Icon svg src="icon_x_rounded.svg" />
            </span>
          )}
          {children}
        </div>
      </StyledModal>
    </Portal>
  )
}

Modal.propTypes = modalType

Modal.defaultProps = {
  close: {
    escape: true,
    overlay: true,
    button: true,
  },
  contentProps: {},
  onClose: () => {},
  transparentBackground: false,
  modalId: MESSAGE_MODAL,
}

export default Modal
